// @flow

import _ from 'lodash'
import type {TerminateCardModuleState} from '../order-terminate-card'
import type {CardSummary} from '../../../types/card-summary'

export default {
  allResults: (state: TerminateCardModuleState): CardSummary[] => {
    return _.unionBy(state.searchResultItemsForCurrentFilter, state.selectedItems, 'cardId')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/order-terminate-card/getters.js